module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.addResForClass
    }
  }, [_vm._v("关联内容")]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "760",
      "footer-hide": ""
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "15px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle"
    }
  }), _vm._v(" "), _c('span', [_vm._v("添加资源")])], 1), _vm._v(" "), _c('div', [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formRes,
      "label-width": "60px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "ID:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "130px"
    },
    model: {
      value: (_vm.formRes.id),
      callback: function($$v) {
        _vm.$set(_vm.formRes, "id", $$v)
      },
      expression: "formRes.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "130px"
    },
    model: {
      value: (_vm.formRes.name),
      callback: function($$v) {
        _vm.$set(_vm.formRes, "name", $$v)
      },
      expression: "formRes.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CP:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formRes.cpId),
      callback: function($$v) {
        _vm.$set(_vm.formRes, "cpId", $$v)
      },
      expression: "formRes.cpId"
    }
  }, _vm._l((_vm.cpList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onQueryBook
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable2",
    staticStyle: {
      "width": "100%",
      "font-size": "13px"
    },
    attrs: {
      "data": _vm.bookData,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleBookSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "书籍ID",
      "align": "center",
      "width": "95"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "书籍名称",
      "align": "center",
      "min-width": "145"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "color": "#1d90e6"
          },
          attrs: {
            "href": "javascript:;"
          },
          on: {
            "click": function($event) {
              return _vm.viewBook(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dbName",
      "label": "CP",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brand",
      "label": "书籍品牌",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.content.brand))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "label": "级别",
      "align": "center",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.content.level))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clevel",
      "label": "当前状态",
      "width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.clevel == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已下架")]) : _vm._e(), _vm._v(" "), (scope.row.clevel == 4) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("审核通过")]) : _vm._e(), _vm._v(" "), (scope.row.clevel == 5) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已上架")]) : _vm._e(), _vm._v(" "), (scope.row.clevel == 2) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("编辑中")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.multyaddBooks
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryBookParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryBookParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageBookTotal
    },
    on: {
      "size-change": _vm.handleBookSizeChange,
      "current-change": _vm.handleBookCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryBookParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryBookParams, "page", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('Divider'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "350px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.modalConfirm
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-370d0bff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/componentsEdu/courseAddBook.vue
// module id = 677
// module chunks = 1